tower.initMobileVerification = ($context, retryInterval = 30) ->
  $mobileCountryCode = $context.find '.mobile-field .country-select'
  $mobileNumber = $context.find '.mobile-field .input-mobile'
  $smsCodeRequestButton = $context.find '.link-request-sms-code'

  smsCodeTimer = null
  smsCodeCountdown = ->
    waitingSeconds = retryInterval
    $smsCodeRequestButton.addClass 'disabled'
    smsCodeTimer && clearInterval(smsCodeTimer)

    smsCodeTimer = setInterval ->
      if waitingSeconds == 0
        clearInterval smsCodeTimer
        $smsCodeRequestButton.text('发送验证码').removeClass 'disabled'
      else
        waitingSeconds -= 1
        $smsCodeRequestButton.text "重新发送(#{waitingSeconds}s)"
    , 1000

  $context.on 'click', '.link-request-sms-code.disabled', (e) ->
    e.stopPropagation()
    e.preventDefault()
    false
  .on 'ajax:beforeSend', '.link-request-sms-code', (e, xhr, settings) ->
    data = $.param
      mobile_verification_request:
        mobile_number: $mobileNumber.val()
        mobile_country_code: $mobileCountryCode.val()
    settings.data += "&#{decodeURIComponent(data)}"
  .on 'ajax:success', '.link-request-sms-code', (e, result) ->
    $mobileNumber.removeClass('error').next('p.error').remove()

    if result.success
      smsCodeCountdown()
    else if result.goto
      if tower.mobile
        tower.visit result.goto
      else
        location.href = result.goto
    else
      $mobileNumber.addClass 'error'
        .after("<p class='error'>#{result.errors[0].msg}</p>")
